import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'
const getNguoiDungKhoState = state => state.nguoiDungKho;

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    Constants.NGUOIDUNGKHO_LIST_API,
    formData
  )

  return handleRequest(request);
}

function detailRequestApi(formData) {
  const request = axiosApi().post(
    Constants.NGUOIDUNGKHO_DETAIL_API,
    formData
  )

  return handleRequest(request);
}

function nguoiDungKhoUpdateRequestApi(formData) {
  const request = axiosApi().post(
    Constants.NGUOIDUNGKHO_UPDATE_API,
    formData
  )

  return handleRequest(request);
}

function* nguoiDungKhoListRequestFlow() {
  const nguoiDungKho = yield select(getNguoiDungKhoState);
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, nguoiDungKho.formData)

    // dispatch the action with our widgets!
    yield put(brActions.nguoiDungKhoListSuccess(results.data))

  } catch (error) {
    yield put(brActions.nguoiDungKhoListError(error))
  }
}

function* nguoiDungKhoDetailRequestFlow() {
  const nguoiDungKho = yield select(getNguoiDungKhoState);
  try {
    // grab the client from our action
    const results = yield call(detailRequestApi, nguoiDungKho.formData)

    // dispatch the action with our widgets!
    yield put(brActions.nguoiDungKhoDetailSuccess(results.data))

  } catch (error) {
    yield put(brActions.nguoiDungKhoDetailError(error))
  }
}

function* nguoiDungKhoUpdateRequestFlow() {
  const nguoiDungKho = yield select(getNguoiDungKhoState);
  try {
    // grab the client from our action
    const result = yield call(nguoiDungKhoUpdateRequestApi, nguoiDungKho.formData)

    // dispatch the action with our widgets!
    yield put(brActions.nguoiDungKhoUpdateSuccess(result));
    if (typeof callback == 'function') {
      nguoiDungKho.callback(results);
    }
  } catch (error) {
    yield put(brActions.nguoiDungKhoUpdateError(error))
  }
}

function* nguoiDungKhoWatcher() {
  yield [
    takeLatest(Constants.NGUOIDUNGKHO_LIST_REQUESTING, nguoiDungKhoListRequestFlow),
    takeLatest(Constants.NGUOIDUNGKHO_DETAIL_REQUESTING, nguoiDungKhoDetailRequestFlow),
    takeLatest(Constants.NGUOIDUNGKHO_UPDATE_REQUESTING, nguoiDungKhoUpdateRequestFlow),
  ]
}

export default nguoiDungKhoWatcher



// WEBPACK FOOTER //
// ./src/views/NguoiDungKho/sagas.js